import React, { useMemo } from 'react';

import {
	ProgressBar,
	IconButton,
	Popover,
} from '@components';

import {
	VolumeLowIcon,
	VolumeMediumIcon,
	VolumeMaxIcon,
} from '@icons';

import './volume.scss';

interface VolumeProps {
	onVolumeChange?: (newVolume: number) => void,
	volume: number,
	disabled?: boolean,
}

function Volume(props: VolumeProps): JSX.Element {
	const {
		onVolumeChange,
		volume,
		disabled,
	} = props;

	const
		progress = useMemo(() => volume * 100, [volume]),
		icon = useMemo(() => {
			if (progress > 50) {
				return <VolumeMaxIcon />
			} else if (progress > 1) {
				return <VolumeMediumIcon />
			} else {
				return <VolumeLowIcon />
			}
		}, [progress]);

	return (
		<div className="volume">
			<Popover
				disabled={disabled}
				placement="top"
				content={
					<ProgressBar
					onProgressChange={onVolumeChange}
					className="volume__progress-bar"
					progress={progress}
					position="vertical"
				/>
			}>
				<IconButton
					className="volume__icon"
					iconSize="30px"
					icon={icon}
					size="nogap"
				/>
			</Popover>
		</div>
	);
}

const MemoisedVolume = React.memo(Volume);

export {MemoisedVolume as Volume};